// Base URLs from environment variables
export const API_URL = process.env.REACT_APP_API_URL || '';

/**
 * Get access token from sessionStorage
 */
export function getAccessToken(): string | null {
  return sessionStorage.getItem('access_token');
}

/**
 * Get headers with Authorization token
 * Cookie認証廃止により、Authorization headerのみを使用
 */
export function getHeaders(includeContentType: boolean = true): HeadersInit {
  const headers: HeadersInit = {};

  if (includeContentType) {
    headers['Content-Type'] = 'application/json';
  }

  const token = getAccessToken();
  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }

  return headers;
}
